export const PASSWORD_MANAGER = {
  TITLE: 'Gestor de Contraseñas',
  VAULT: {
    TITLE: 'Almacén de Contraseñas',
    DESCRIPTION:
      'Accede al almacén de contraseñas de tu organización para gestionar de forma segura ' +
      'las credenciales compartidas.',
    URLS: {
      ACCESS: 'Acceder al almacén de contraseñas',
    },
  },
  EXTENSION: {
    TITLE: 'Extensión de Navegador',
    DESCRIPTION:
      'Instala nuestra extensión de gestor de contraseñas para el navegador y ' +
      'accede fácilmente a tus credenciales.',
    URLS: {
      DOWNLOAD: 'Descargar extensión para Google Chrome',
    },
  },
  DOCUMENTATION: {
    TITLE: 'Documentación',
    DESCRIPTION:
      'Aprende a utilizar eficazmente nuestras herramientas de gestión de contraseñas y ' +
      'las mejores prácticas para la seguridad de las mismas.',
    URLS: {
      GUIDE: 'Manual del Gestor de Contraseñas',
      EXTENSION: 'Instalación de la extensión para Google Chrome',
    },
  },
  INSIGHTS: {
    TITLE: 'Insights de Seguridad de Contraseñas',
    DESCRIPTION:
      'Revisa los insights y recomendaciones de seguridad de contraseñas para fortalecer ' +
      'las prácticas de tu organización. Monitorea la salud de las contraseñas, identifica ' +
      'contraseñas débiles o reutilizadas y sigue la mejora a lo largo del tiempo.',
    NO_INSIGHTS_AVAILABLE:
      'Los insights de contraseñas estarán disponibles una vez que se haya ' +
      'recopilado suficiente información. Por favor, vuelve más tarde para revisar los patrones ' +
      'y recomendaciones de seguridad de contraseñas.',
  },
}
